export default __webpack_public_path__ + "static/media/miguel-lopes-35.dd29a3f7.jpg";